import { render } from "./Model.vue?vue&type=template&id=9f384494"
import script from "./Model.vue?vue&type=script&lang=js"
export * from "./Model.vue?vue&type=script&lang=js"
script.render = render

export default script